// Auto-generated from Google Drive business assets.
export const brandAssets = {
  "logos": {
    "primary": {
      "source": "LOGO_BLANCO_CON_LLAMA_ROJA_ACTUALIZADO.png",
      "originalSize": [3913, 1906],
      "paths": {
        "png": "/assets/la-capital/logos/la-capital-logo-white-flame.png",
        "sm": "/assets/la-capital/logos/la-capital-logo-white-flame-sm.webp",
        "lg": "/assets/la-capital/logos/la-capital-logo-white-flame-lg.webp",
        "xl": "/assets/la-capital/logos/la-capital-logo-white-flame-xl.webp"
      }
    },
    "original": {
      "source": "logo_original_png.png",
      "originalSize": [2057, 1308],
      "paths": {
        "png": "/assets/la-capital/logos/la-capital-logo-original.png",
        "sm": "/assets/la-capital/logos/la-capital-logo-original-sm.webp",
        "lg": "/assets/la-capital/logos/la-capital-logo-original-lg.webp",
        "xl": "/assets/la-capital/logos/la-capital-logo-original-xl.webp"
      }
    },
    "favicon": "/favicon.png",
    "og": "/assets/la-capital/logos/la-capital-og.jpg"
  },
  "food": [
    {
      "slug": "burger_bacon_real",
      "source": "Fotos/Hamburguesas/Bacon.jpg",
      "originalSize": [
        1080,
        1350
      ],
      "paths": {
        "card": "/assets/la-capital/food/burger_bacon_real-card.webp",
        "wide": "/assets/la-capital/food/burger_bacon_real-wide.webp",
        "hero": "/assets/la-capital/food/burger_bacon_real-hero.webp"
      },
      "legacy": "src/assets/images/burger_bacon_real.jpg"
    },
    {
      "slug": "burger_buffalo_real",
      "source": "Fotos/Hamburguesas/Hamburguesa Pollo buffalo.jpg",
      "originalSize": [
        1080,
        1350
      ],
      "paths": {
        "card": "/assets/la-capital/food/burger_buffalo_real-card.webp",
        "wide": "/assets/la-capital/food/burger_buffalo_real-wide.webp",
        "hero": "/assets/la-capital/food/burger_buffalo_real-hero.webp"
      },
      "legacy": "src/assets/images/burger_buffalo_real.jpg"
    },
    {
      "slug": "burger_capital_mermelada_real",
      "source": "Fotos/Hamburguesas/Memelada bacon.jpg",
      "originalSize": [
        4211,
        2811
      ],
      "paths": {
        "card": "/assets/la-capital/food/burger_capital_mermelada_real-card.webp",
        "wide": "/assets/la-capital/food/burger_capital_mermelada_real-wide.webp",
        "hero": "/assets/la-capital/food/burger_capital_mermelada_real-hero.webp"
      },
      "legacy": "src/assets/images/burger_capital_mermelada_real.jpg"
    },
    {
      "slug": "burger_mushrooms_real",
      "source": "Fotos/Hamburguesas/hamburguesa de champiñones.jpg",
      "originalSize": [
        1080,
        1350
      ],
      "paths": {
        "card": "/assets/la-capital/food/burger_mushrooms_real-card.webp",
        "wide": "/assets/la-capital/food/burger_mushrooms_real-wide.webp",
        "hero": "/assets/la-capital/food/burger_mushrooms_real-hero.webp"
      },
      "legacy": "src/assets/images/burger_mushrooms_real.jpg"
    },
    {
      "slug": "nachos_birria_real",
      "source": "Fotos/Tex Mex/NACHOS BIRRIA.jpg",
      "originalSize": [
        1080,
        1350
      ],
      "paths": {
        "card": "/assets/la-capital/food/nachos_birria_real-card.webp",
        "wide": "/assets/la-capital/food/nachos_birria_real-wide.webp",
        "hero": "/assets/la-capital/food/nachos_birria_real-hero.webp"
      },
      "legacy": "src/assets/images/nachos_birria_real.jpg"
    },
    {
      "slug": "nachos_buffalo_porcion_real",
      "source": "Fotos/Tex Mex/Nachos pollo buffalo 1 porcion.jpg",
      "originalSize": [
        1080,
        1350
      ],
      "paths": {
        "card": "/assets/la-capital/food/nachos_buffalo_porcion_real-card.webp",
        "wide": "/assets/la-capital/food/nachos_buffalo_porcion_real-wide.webp",
        "hero": "/assets/la-capital/food/nachos_buffalo_porcion_real-hero.webp"
      },
      "legacy": "src/assets/images/nachos_buffalo_porcion_real.jpg"
    },
    {
      "slug": "nachos_buffalo_close_real",
      "source": "Fotos/Tex Mex/Nachos pollo buffalo(1).jpg",
      "originalSize": [
        1080,
        1350
      ],
      "paths": {
        "card": "/assets/la-capital/food/nachos_buffalo_close_real-card.webp",
        "wide": "/assets/la-capital/food/nachos_buffalo_close_real-wide.webp",
        "hero": "/assets/la-capital/food/nachos_buffalo_close_real-hero.webp"
      },
      "legacy": "src/assets/images/nachos_buffalo_close_real.jpg"
    },
    {
      "slug": "nachos_buffalo_table_real",
      "source": "Fotos/Tex Mex/Nachos pollo buffalo.jpg",
      "originalSize": [
        2811,
        4211
      ],
      "paths": {
        "card": "/assets/la-capital/food/nachos_buffalo_table_real-card.webp",
        "wide": "/assets/la-capital/food/nachos_buffalo_table_real-wide.webp",
        "hero": "/assets/la-capital/food/nachos_buffalo_table_real-hero.webp"
      },
      "legacy": "src/assets/images/nachos_buffalo_table_real.jpg"
    },
    {
      "slug": "quesibirria_real",
      "source": "Fotos/Tex Mex/QUESIBIRRIA LA CAPITAL.jpg",
      "originalSize": [
        1080,
        1350
      ],
      "paths": {
        "card": "/assets/la-capital/food/quesibirria_real-card.webp",
        "wide": "/assets/la-capital/food/quesibirria_real-wide.webp",
        "hero": "/assets/la-capital/food/quesibirria_real-hero.webp"
      },
      "legacy": "src/assets/images/quesibirria_real.jpg"
    },
    {
      "slug": "canasta_birria_real",
      "source": "Fotos/Tex Mex/canasta de birria.jpg",
      "originalSize": [
        1080,
        1350
      ],
      "paths": {
        "card": "/assets/la-capital/food/canasta_birria_real-card.webp",
        "wide": "/assets/la-capital/food/canasta_birria_real-wide.webp",
        "hero": "/assets/la-capital/food/canasta_birria_real-hero.webp"
      },
      "legacy": "src/assets/images/canasta_birria_real.jpg"
    }
  ],
  "pdfMenus": [
    {
      "source": "Menu La Capital/MENU 2025.pdf",
      "pages": 8,
      "paths": [
        "/assets/la-capital/menu-pdf/menu-2025-page-1.webp",
        "/assets/la-capital/menu-pdf/menu-2025-page-2.webp",
        "/assets/la-capital/menu-pdf/menu-2025-page-3.webp",
        "/assets/la-capital/menu-pdf/menu-2025-page-4.webp",
        "/assets/la-capital/menu-pdf/menu-2025-page-5.webp",
        "/assets/la-capital/menu-pdf/menu-2025-page-6.webp",
        "/assets/la-capital/menu-pdf/menu-2025-page-7.webp",
        "/assets/la-capital/menu-pdf/menu-2025-page-8.webp"
      ]
    }
  ]
}
